import React from "react";
import { Paper, Typography, Box, Stack } from "@mui/material";

// Helper function to get primary media URL (duplicated from other components)
const getPrimaryMediaUrl = (product) => {
  // ✅ For Similar Products API
  if (product?.imageUrl) {
    return product.imageUrl;
  }

  // ✅ For Full Product API
  if (product?.images?.length > 0 && product.images[0]?.url) {
    return product.images[0].thumbnailUrl;
  }

  if (product?.videos?.length > 0 && product.videos[0]?.thumbnailUrl) {
    return product.videos[0].thumbnailUrl;
  }

  return "/placeholder-product.png";
};

const RecentlyViewed = ({ products = [], navigate }) => (
  <Paper sx={{ mt: 3, p: 3, borderRadius: 3 }}>
    <Typography fontWeight={700} mb={2}>
      Recently Viewed
    </Typography>

    <Stack direction="row" spacing={2} sx={{ overflowX: "auto" }}>
      {products.slice(0, 6).map((p) => (
        <Box
          key={p._id}
          sx={{
            width: { xs: 130, sm: 160 },
            cursor: "pointer",
            flexShrink: 0,
          }}
          onClick={() => navigate(`/product/${p._id}`)}
        >
          <Box
            sx={{
              width: { xs: 70, sm: 120 },
              textAlign: "center",
            }}
          >
            <img
              src={p.images[0].thumbnailUrl || getPrimaryMediaUrl(p)}
              alt={p.title}
              loading="lazy"
              style={{
                width: "100%",
                height: "100%",
                objectFit: "contain",
              }}
            />
          </Box>

          <Typography
            variant="body2"
            sx={{
              mt: 1,
              fontWeight: 500,
              lineHeight: 1.2,
              height: 34,
              overflow: "hidden",
              display: "-webkit-box",
              WebkitLineClamp: 2,
              WebkitBoxOrient: "vertical",
            }}
          >
            {p.title}
          </Typography>

          <Typography
            sx={{
              fontWeight: 700,
              color: "#B12704", // Amazon price color
              fontSize: 14,
            }}
          >
            ₹{Number(p.price || 0).toLocaleString("en-IN")}
          </Typography>
        </Box>
      ))}
    </Stack>
  </Paper>
);

export default RecentlyViewed;